// extracted by mini-css-extract-plugin
export var container = "_6c-1";
export var cornerButtonContainer = "_6c-5";
export var disabled = "_6c-2";
export var fileContainer = "_6c-4";
export var hiddenInput = "_6c-3";
export var widthContainer = "_6c-0";